import styled from '@emotion/styled/macro'

import { headingFontSize } from './basis'

export const H1 = styled.h1`
  font-style: normal;
  text-decoration: none;
  font-size: ${headingFontSize};
  font-family: 'PT-Astra-Serif', serif;
  font-weight: bold;
`
